module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v("A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UTHOR’S ")]), _vm._v("N"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OTE")])]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_vm._v("It needs to be said one more time. This is a novel. Nothing of what you are about to read actually happened. But as I can’t ignore what I read every day in the newspapers, it’s inevitable that my story draws on real life. Because that’s where everything is being decided—in real life. And in real life, the horror is greater—far greater—than anything that can possibly be invented. As for Marseilles, my city, always halfway between tragedy and light, it naturally reflects the threat hanging over us.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22580ddf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/solea_00004.vue
// module id = 78
// module chunks = 0